import { Outlet, useNavigate } from 'react-router-dom';

import { Close } from 'components/svg';
import useLocale from 'hooks/locale/useLocale';

import './fortuneWheelLayout.scss';

const FortuneWheelLayout = () => {
    const navigate = useNavigate();
    const lang = useLocale();

    return (
        <div className="fortune-wheel-layout container pos-relative mh-100vh d-flex flex-column">
            <Close
                onClick={() => {
                    navigate(-1, { preventScrollReset: true });
                }}
            />
            <div className="d-flex flex-grow-1" style={{ marginTop: '2.5rem' }}>
                <Outlet />
            </div>
        </div>
    );
};

export default FortuneWheelLayout;
